export const ALL_SUPPORT_ARTICLES_CATEGORY = "All";
export const MAX_SUPPORT_ARTICLE_SUGGESTIONS = 5;
